import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import {
  faFacebookF,
  faInstagram,
  faPinterestP,
  faTwitter
} from '@fortawesome/free-brands-svg-icons';
import { faPrint, faEnvelope } from '@fortawesome/fontawesome-free-solid';
import './socialLinks.css';

function SocialLinks() {
  return (
    <div className="socialLinks">
      <Link to="/">
        <FontAwesomeIcon icon={faPrint} />
      </Link>
      <Link to="/">
        <FontAwesomeIcon icon={faEnvelope} />
      </Link>
      <Link to="/">
        <FontAwesomeIcon icon={faPinterestP} />
      </Link>
      <Link to="/">
        <FontAwesomeIcon icon={faTwitter} />
      </Link>
      <Link to="/">
        <FontAwesomeIcon icon={faFacebookF} />
      </Link>
      <Link to="/">
        <FontAwesomeIcon icon={faInstagram} />
      </Link>
    </div>
  );
}

export default SocialLinks;
